import React from "react";
import styles from "./services.module.css";
import { TextComponent } from "../../../../../components";

const services = [
  "Wedding Photographer",
  "Engagement Photographer",
  "Portrait Photographer",
  "Event Photographer",
];

function Services() {
  return (
    <div className={styles.mainDiv}>
      <TextComponent text={"Services"} textClass={styles.textHeading} />
      {services.map((data) => (
        <TextComponent text={data} textClass={styles.servText} />
      ))}
    </div>
  );
}

export default Services;
